// Angular
import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  NgZone,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
// External
import { FormGroup, FormControl, Validators } from "@angular/forms";

import { Post } from "../../models/post";
import { FormsService } from "../../services/forms";

import { AngularFireDatabase } from "angularfire2/database";
import * as lodash from "lodash";
import { AngularFireAuth } from "angularfire2/auth";
import * as moment from "moment";
import { FirebaseApp } from "angularfire2";
import { ApiService } from "./../../services/api";
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from "@angular/platform-browser";
import { MatSnackBar } from "@angular/material";
import { MapsAPILoader } from "@agm/core";
import { ElasticService } from "app/services/elastic";
import { OAuthService } from "app/services/o-auth";

@Component({
  templateUrl: "./company.detail.component.html",
})
export class CompanyDetailComponent implements OnInit {
  public avatarLoading: boolean;
  public post: any;
  public shared: Post;
  public form: FormGroup;
  public emailForm: FormGroup;
  public addMemberForm: FormGroup;
  public postData: any;
  public likeCount: number;
  public commentCount: number;
  public mentionCount: number;
  public mentioned: Array<any>;
  public commentList: Array<any>;
  public isEmailModal = false;
  public latitude: number;
  public longitude: number;
  public zoom: number;
  public user: any = {};
  public users: Array<any> = [];
  public query: string = "";
  public memberSize: number;
  private typingDelay: any;
  public display1 = "none";
  public display2 = "none";
  public display3 = "none";
  public display4 = "none";
  public loggedInuser = {};
  public commission: number = 10;
  public error: any = {
    addressError: false,
    phoneError: false,
    emailError: false,
    contactPersonNameError: false,
    contactPersonEmailError: false,
    accountTypeError: false,
    infoError: false,
  };

  public likeList: Array<{ author: string; authorImage: string; key: string }>;
  public shareLikes: Array<{
    author: string;
    authorImage: string;
    key: string;
  }>;
  public shareComments: Array<any>;
  public imageLoader: boolean = true;
  private postId: string;
  private author: string;
  public followerCount = 0;
  public postCount = 0;
  private attachmentExt: string;
  public text: string;

  public userId: string;
  public profile: any = {};
  public list: Array<any> = [];
  public selectedItem = {};

  public isReset = false;
  public attachmentFiles: any;
  public gallery: Array<any>;
  public insights: Array<any>;
  public members: Array<any>;
  public club: any = {};

  @ViewChild("search")
  public searchElementRef: ElementRef;
  constructor(
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private _sanitizer: DomSanitizer,
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService,
    private firebase: FirebaseApp,
    private fireAuth: AngularFireAuth,
    public formsService: FormsService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private elasticService: ElasticService,
    private oAuthService: OAuthService
  ) {
    this.form = new FormGroup({
      title: new FormControl("", Validators.required),
      body: new FormControl("", Validators.required),
      address: new FormControl("", Validators.required),
      state: new FormControl("", Validators.required),
      country: new FormControl("", Validators.required),
      postCode: new FormControl("", Validators.required),
      city: new FormControl("", Validators.required),
    });
    this.addMemberForm = new FormGroup({
      fullName: new FormControl("", Validators.required),
      role: new FormControl(1, Validators.required),
      email: new FormControl("", Validators.required),
      username: new FormControl("", Validators.required),
      phone: new FormControl("", Validators.required),
      password: new FormControl("", Validators.required),
    });
  }

  getClubMembers() {
    const fireObject = this.fireDatabase
      .object(`/club-members/${this.userId}`)
      .subscribe((result) => {
        console.log(result);
        this.members = [];
        if (result) {
          lodash.forEach(result, async (item, key) => {
            if (item) {
              let user = await this.apiService.object(`/users/${key}`);
              let profile = await this.apiService.object(
                "user-profiles/" + key + "/" + this.userId
              );
              user.status = profile.status ? profile.status : 1;
              user.isVerified = profile.isVerified ? profile.isVerified : true;
              user.role = profile.role ? profile.role : true;

              this.members.push(user);
            }
          });
        }
      });
  }

  public openModel1() {
    this.display3 = "block";
    $("#addMemberModal").modal("show");
    this.addMemberForm.reset({
      fullName: null,
      role: 1,
      email: null,
      username: null,
      phone: null,
      password: null,
    });
  }

  public openModel() {
    this.display2 = "block";
    $("#editModal").modal("show");
    this.addMemberForm.reset({
      fullName: null,
      role: 1,
      email: null,
      username: null,
      phone: null,
      password: null,
      confirm: null,
    });
  }

  //moved to  addMemberSubmit()
  // addMember() {
  //   console.log(this.addMemberForm.value);
  //   const email = this.addMemberForm.value.email;
  //   let cid = this.userId;
  //   var memberId = cid;

  //   const username = this.addMemberForm.value.username;
  //   const phone = this.addMemberForm.value.phone;
  //   const fullName = this.addMemberForm.value.fullName;
  //   let key = this.userId;

  //   let req = {
  //     registerDate: moment().unix(),
  //     email: email,
  //     username: username,
  //     password: this.addMemberForm.value.password,
  //     fullName: fullName,
  //     memberId: memberId,
  //     role: 1,
  //     type: this.profile.type,
  //     status: 1,
  //     cid: this.userId,
  //     phone: phone,
  //     isVerified: true,
  //     updatedAt: new Date().getTime() / 1000,
  //     isMember: true,
  //   };

  //   this.apiService
  //     .set(`/server-process/create-user/${key}`, req)

  //     .then(() => {
  //       return $("#addMemberModal").modal("hide");
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       alert(error);
  //     });
  // }

  generatePwd() {
    this.addMemberForm.controls.password.setValue(
      this.addMemberForm.value.username + "@" + new Date().getFullYear()
    );
  }

  async ngOnInit() {
    this.userId = this.route.snapshot.params["id"];
    this.loggedInuser = this.oAuthService.getClub();

    if (!this.userId) {
      return;
    }

    this.fireDatabase.object(`/users/${this.userId}`).subscribe(
      (result) => {
        this.gallery = [];
        result["appversion"] = result["app-version"];
        if (result.gallery) {
          lodash.forEach(result.gallery, (item, key) => {
            if (item && item.original) {
              this.gallery.push({
                original: item.original,
                cropped: item.cropped,
                key: key,
                isActive: false,
              });
              this.gallery = lodash.orderBy(this.gallery, ["sort"], ["asc"]);
            }
          });
        }

        this.profile = result;

        switch (this.profile.type) {
          case 5:
            this.profile.type_name = "Company";
            this.profile.url = "/components/company-profile-submenu";
            break;
          case 6:
            this.profile.type_name = "Society";
            this.profile.url = "/components/society-profile-submenu";
            break;
          case 7:
            this.profile.type_name = "Tour";
            this.profile.url = "/components/tour-profile-submenu";
            break;
        }

        if (this.profile.commission) {
          this.commission = this.profile.commission;
        } else {
          this.commission = 0;
        }

        if (this.profile.type == 7) this.getTourInsights();

        if (this.profile.type == 6) this.getSocietyInsights();

        if (this.profile.type == 5) this.getCompanyInsights();

        this.imageLoader = false;
      },
      (error) => {
        console.error(error);
        this.imageLoader = false;
      }
    );
    let count = 0;

    this.fireDatabase.list(`/users-posts/${this.userId}`).subscribe(
      (result: Array<any>) => {
        lodash.forEach(result, (item) => {
          count++;

          if (item.author) {
            ++this.postCount;
            this.fireDatabase
              .object(`/users/${item.author}`)
              .subscribe((user: any) => {
                item.author_name = user.username;
              });
          }
          const date = new Date(item.date * 1000);

          const o =
            date.getFullYear() +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + date.getDate()).slice(-2);
          item.date = o;
          if (count === 1) {
            this.postDetail(item);
          }
          this.list.push(item);
        });
      },
      (error) => {
        console.error(error);
      }
    );
    this.fireDatabase.object(`/user-followers/${this.userId}`).subscribe(
      (result) => {
        if (result.count) {
          this.followerCount = result.count;
        } else {
          this.followerCount = 0;
        }
      },
      (error) => {
        console.error(error);
      }
    );

    this.zoom = 4;
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ["address"],
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          const results = place.address_components;

          this.form.patchValue({ address: place.formatted_address });

          this.form.controls["postCode"].patchValue(
            this.findResult(results, "postal_code")
          );
          this.form.controls["state"].patchValue(
            this.findResult(results, "administrative_area_level_1")
          );
          this.form.controls["country"].patchValue(
            this.findResult(results, "country")
          );

          this.form.controls["city"].patchValue(
            this.findResult(results, "administrative_area_level_2")
          );
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          // console.log(this.form.value);
          this.profile.address = this.form.controls.address.value;

          this.zoom = 12;
        });
      });
    });
    this.getClubMembers();
  }

  getTourInsights() {
    this.apiService.list("master/tour-insights").then((res) => {
      this.insights = [];
      if (res && res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          let element = res[i];
          element.isSelected = false;

          if (this.profile.insights && this.profile.insights[element.$key]) {
            element.isSelected = this.profile.insights[element.$key] == 1;
          }
          if (element.status == 1) this.insights.push(element);
        }
      }
    });
  }

  getSocietyInsights() {
    this.apiService.list("master/society-insights").then((res) => {
      this.insights = [];
      if (res && res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          let element = res[i];
          element.isSelected = false;

          if (this.profile.insights && this.profile.insights[element.$key]) {
            element.isSelected = this.profile.insights[element.$key] == 1;
          }
          if (element.status == 1) this.insights.push(element);
        }
      }
    });
  }

  getCompanyInsights() {
    this.apiService.list("master/company-insights").then((res) => {
      this.insights = [];
      if (res && res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          let element = res[i];
          element.isSelected = false;

          if (this.profile.insights && this.profile.insights[element.$key]) {
            element.isSelected = this.profile.insights[element.$key] == 1;
          }
          if (element.status == 1) this.insights.push(element);
        }
      }
    });
  }

  remove(post, i) {
    if (confirm(`Are you sure to delete post?`)) {
      this.fireDatabase.database
        .ref(`/server-process/post-to-remove/${post.$key}`)
        .set(post.author)
        .then(() => {
          this.list.splice(i, 1);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  formatTime(timestamp) {
    const date = new Date(timestamp * 1000);

    // const time1 = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`

    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }
  public submit() {
    this.fireDatabase.database
      .ref(
        `/server-process/admin-notification/${this.userId}/${this.fireAuth.auth.currentUser.uid}`
      )
      .set(this.form.value)
      .then(() => {
        alert("Notification is Sent!");
      })
      .catch((error) => {
        console.error(error);
      });
  }
  postDetail(post: Post) {
    $("html, body").animate({ scrollTop: "1px" });
    this.commentList = [];
    this.likeList = [];
    this.shareLikes = [];
    this.shareComments = [];
    this.postData = post;
    if (post.photo) {
      this.attachmentExt = post.photo.url;
    }
    this.text = this.postData.text;
    this.fireDatabase.object(`/users/${post.author}`).subscribe((user: any) => {
      this.postData.authorName = user.username;
      this.postData.authorImage = user.avatar_thumb;
    });
    if (this.postData.mentioned) {
      this.mentioned = [];
      this.mentionCount = 0;
      lodash.forEach(this.postData.mentioned, (mention, key) => {
        this.mentionCount++;
        this.mentioned.push({
          user_name: mention.username,
          user_id: key,
        });
      });
    }
    if (this.postData.shared) {
      this.fireDatabase
        .object(
          `/users-posts/${this.postData.shared.uid}/${this.postData.shared.pid}`
        )
        .subscribe((shared) => {
          this.shared = shared;
          if (shared.$value) {
            this.postData.isShared = true;
            console.log(this.shared);
            this.fireDatabase
              .object(`/users/${shared.author}`)
              .subscribe((user: any) => {
                this.postData.Sharedauthor = user.username;
                this.postData.SharedauthorImage = user.avatar_thumb;
              });
            this.fireDatabase
              .object(`/posts/${this.shared.$key}/likes`)
              .subscribe((likes) => {
                if (likes) {
                  lodash.forEach(likes, (like) => {
                    this.fireDatabase
                      .object(`/users/${like}`)
                      .subscribe((user: any) => {
                        like = user.username;
                        this.shareLikes.push({
                          author: user.username,
                          authorImage: user.avatar_thumb,
                          key: user.$key,
                        });
                      });
                  });
                }
              });
            this.fireDatabase
              .object(`/posts/${this.shared.$key}/comments`)
              .subscribe((comments) => {
                if (comments) {
                  lodash.forEach(comments, (comment) => {
                    if (comment) {
                      this.fireDatabase
                        .object(`/users/${comment.author}`)
                        .subscribe((user: any) => {
                          comment.author = user.username;
                          comment.authorImage = user.avatar_thumb;
                          comment.key = user.$key;
                          this.shareComments.push(comment);
                        });
                    }
                  });
                }
              });
          }
        });
    } else {
      this.postData.isShared = false;
    }
    this.fireDatabase.object(`/posts/${post.$key}/likes`).subscribe((likes) => {
      this.likeCount = 0;
      if (likes) {
        lodash.forEach(likes, (item, like) => {
          this.likeCount++;
          if (item) {
            this.fireDatabase
              .object(`/users/${like}`)
              .subscribe((user: any) => {
                like = user.username;
                this.likeList.push({
                  author: user.username,
                  authorImage: user.avatar_thumb,
                  key: user.$key,
                });
              });
          }
        });
      }
    });
    this.fireDatabase
      .object(`/posts/${post.$key}/comments`)
      .subscribe((comments) => {
        this.commentCount = 0;
        if (comments) {
          lodash.forEach(comments, (comment) => {
            this.commentCount++;
            if (comment) {
              this.fireDatabase
                .object(`/users/${comment.author}`)
                .subscribe((user: any) => {
                  comment.author = user.username;
                  comment.authorImage = user.avatar_thumb;
                  comment.key = user.$key;
                  this.commentList.push(comment);
                  // this.postData.date = moment().unix();
                  lodash.forEach(this.commentList, (item) => {
                    console.log(item);
                    item.date = new Date(item.date * 1000);
                    var dd = item.date.getDate();
                    var mm = item.date.getMonth() + 1;
                    var yyyy = item.date.getFullYear();
                    item.date = dd + "/" + mm + "/" + yyyy;
                    console.log(item.date);
                  });
                });
            }
          });
        }
      });
  }

  private uploadFile(): Promise<any> {
    var promises = [];
    if (this.attachmentFiles) {
      for (var i = 0; i < this.attachmentFiles.length; i++) {
        const element = this.attachmentFiles[i];
        const newImage = new Promise((resolve, reject) => {
          const filename = `${moment().unix()}.${Math.floor(
            Math.random() * 900 + 100
          )}`;
          this.firebase
            .storage()
            .ref(`/attachments/${this.fireAuth.auth.currentUser.uid}`)
            .child(filename)
            .put(element.file)
            .then((result) => resolve(result))
            .catch((error) => reject(error));
        });
        promises.push(newImage);
      }
    }

    return Promise.all(promises);
  }

  public changeAttachment(attachments) {
    this.attachmentFiles = attachments;
  }
  public submitAttachment() {
    this.uploadFile().then((results) => {
      var urls = {};
      for (var i = 0; i < results.length; i++) {
        var element = results[i];
        urls["image" + i + Math.floor(Math.random() * 900 + 100)] =
          element.downloadURL;
      }

      if (this.gallery && this.gallery.length > 0) {
        for (let k = 0; k < this.gallery.length; k++) {
          const element = this.gallery[k];
          urls[element.key] = element.url;
        }
      }

      this.apiService
        .set("users/" + this.userId + "/gallery/", urls)
        .then((data) => {
          this.isReset = true;
          this.attachmentFiles = [];
        });
    });
  }

  public delete(key) {
    if (confirm("Are you sure? you want to delete this image")) {
      this.apiService
        .set("users/" + this.userId + "/gallery/" + key, null)
        .then((data) => {
          console.log(data);
        });
    }
  }

  public getBackground(image) {
    return this._sanitizer.bypassSecurityTrustStyle(` url(${image})`);
  }

  public imageClick(index) {
    for (let i = 0; i < this.gallery.length; i++) {
      const element = this.gallery[i];
      element.isActive = false;
    }
    this.gallery[index].isActive = true;
    this.display1 = "block";
    $("#myModal").modal("show");
  }
  public moveLeft() {
    let i = this.gallery.findIndex((item) => item.isActive == true);
    this.gallery[i].isActive = false;
    if (i != 0) {
      this.gallery[i - 1].isActive = true;
    } else {
      this.gallery[this.gallery.length - 1].isActive = true;
    }
  }
  public moveRight() {
    let i = this.gallery.findIndex((item) => item.isActive == true);
    this.gallery[i].isActive = false;
    if (i != this.gallery.length - 1) {
      this.gallery[i + 1].isActive = true;
    } else {
      this.gallery[0].isActive = true;
    }
  }
  public insightSelect(select, insight) {
    let status = select == true ? 1 : null;
    this.apiService.set(
      `/users/${this.userId}/insights/${insight.$key}`,
      status
    );

    this.snackBar.open("Insight updated successfully!!", "OK!", {
      duration: 3000,
    });
  }

  public changeBackground(event): void {
    if (!event.target.files.length) {
      return;
    }

    const file = event.target.files.item(0);
    const fileExt = file.name.split(".").pop();
    const fileName = `${this.userId}_${moment().unix()}.${fileExt}`;
    this.imageLoader = true;
    this.apiService
      .upload("/users/background", fileName, file, {
        customMetadata: { uid: this.userId },
      })
      .then((result) => {
        if (result && result.downloadURL) {
          const image = new Image();
          image.src = result.downloadURL;
          image.onload = () => {
            this.imageLoader = false;
            this.profile.background = result.downloadURL;
          };
          image.onerror = () => {
            this.imageLoader = false;
          };
        } else {
          this.imageLoader = false;
        }
      })
      .catch((error) => {
        console.error(error);

        this.imageLoader = false;
      });
  }

  public changeAvatar(event): void {
    if (!event.target.files.length) {
      return;
    }

    const file = event.target.files.item(0);
    const fileExt = file.name.split(".").pop();
    const fileName = `${this.userId}_${moment().unix()}.${fileExt}`;

    this.avatarLoading = true;
    this.apiService
      .upload("/users/avatars", fileName, file, {
        customMetadata: { uid: this.userId },
      })
      .then((result) => {
        if (result && result.downloadURL) {
          const image = new Image();
          image.src = result.downloadURL;
          image.onload = () => {
            this.avatarLoading = false;
            this.profile.avatar = result.downloadURL;
          };
          image.onerror = () => {
            this.avatarLoading = false;
          };
        } else {
          this.avatarLoading = false;
        }
      })
      .catch((error) => {
        console.error(error);

        this.avatarLoading = false;
      });
  }

  toggleEmail() {
    this.isEmailModal = !this.isEmailModal;
    this.openModel();
  }

  changeProfileSubmit() {
    Object.keys(this.profile).forEach((key) => {
      if (this.profile[key] == undefined) {
        delete this.profile[key];
      }
    });

    if (!this.profile.email) {
      this.error.emailError = true;
      return;
    } else {
      this.error.emailError = false;
    }
    if (!this.profile.contactPersonName) {
      this.error.contactPersonNameError = true;
      return;
    } else {
      this.error.contactPersonNameError = false;
    }
    if (!this.profile.contactPersonEmailId) {
      this.error.contactPersonEmailError = true;
      return;
    } else {
      this.error.contactPersonEmailError = false;
    }
    if (!this.profile.isPrivate && this.profile.type != 5) {
      this.error.accountTypeError = true;
      return;
    } else {
      this.error.accountTypeError = false;
    }

    this.imageLoader = true;
    this.profile.isPrivate = +this.profile.isPrivate;
    $("#changeEmailModal").modal("hide");
    this.toggleEmail();
    this.fireAuth.auth
      .fetchProvidersForEmail(this.profile.email)
      .then((result) => {
        this.apiService
          .set(
            `/server-process/change-user-email/${this.profile.uid}/${this.userId}`,
            this.profile.email
          )
          .then(async () => {
            try {
              await this.apiService.set(`/users/${this.userId}`, this.profile);
              alert("Profile updated successfully");
              $("#editModal").modal("hide");
              this.imageLoader = false;
            } catch (error) {
              this.imageLoader = false;
              console.log(error);
            }
          })
          .catch((error) => {
            this.imageLoader = false;
            console.error(error);
          });
      });
    $("#editModal").modal("hide");
  }

  public findResult = function (results, name) {
    const result = lodash.find(results, function (obj) {
      return obj.types[0] === name;
    });
    return result ? result.long_name : null;
  };

  canDeactivate(): Promise<boolean> | boolean {
    $("#editModal").modal("hide");
    return true;
  }

  onFocus() {
    this.searchMention();
  }

  onBlur() {
    setTimeout(() => {
      this.users = [];
    }, 500);
  }

  searchMention() {
    const queryParams = {
      index: "users",
      type: "user",
      "body/query/bool/must/query_string/query": `${this.query}*`,
      "body/query/bool/must/query_string/fields": ["fullName^10", "username^2"],
    };
    this.elasticService
      .search(queryParams)
      .then((result) => {
        this.users = [];
        if (result && result["hits"]) {
          lodash.forEach(result["hits"], async (item) => {
            const user = lodash.assign({ $key: item["_id"] }, item["_source"]);

            if (user.$key) {
              user.key = user.$key;
            }
            let firebaseUser = await this.apiService.object(
              `users/${user.key}`
            );
            if (!firebaseUser.deactivated) {
              this.users.push(user);
            }
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  changeQuery() {
    clearTimeout(this.typingDelay);
    this.typingDelay = setTimeout(() => {
      this.searchMention();
    }, 400);
  }

  chooseUser(user) {
    this.user = user;
    this.query = user.username
    this.users=[]
  }

  addMemberSubmit() {
    let clubId = this.userId;
    let req = {
      role: 1,
      type: this.profile.type,
      status: 1,
      isVerified: true,
      updatedAt: new Date().getTime() / 1000,
    };
    let memberId = this.user.key;
    if (this.user.$key) {
      memberId = this.user.$key;
    }
    this.apiService
      .set(`/server-process/add-member/${clubId}/${memberId}`, req)
      .then(() => {
        // location.reload()
        this.closeModal();
      })
      .catch((error) => {
        console.error(error);
        alert(error);
      });
    $("#addMemberModal").modal("hide");
  }

  closeModal() {
    this.user = {};
    this.query = "";
    $("#addMemberModal").modal("hide");
  }

  updateCommissionModal() {
    this.display4 = "block";
    this.commission = this.profile.commission;
    $("#changeCommissionModal").modal("show");
  }

  closeCommisionModal() {
    this.display4 = "none";

    $("#changeCommissionModal").modal("hide");
  }

  updateCommision() {
    this.profile.commission = this.commission;
    this.apiService
      .set(`users/${this.userId}/commission`, this.commission)
      .then((data) => {
        $("#changeCommissionModal").modal("hide");
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
